import React from "react";
import "../../App.css";
import ReactPlayer from "react-player";

function Railway() {
  return (
    <div className="reel">
      <>
        <ReactPlayer
          url="https://www.youtube.com/watch?v=wqMJk0MJuhc&t=1s"
          width="100%"
          height="100%"
          controls={true}
        />
      </>
    </div>
  );
}

export default Railway;
